import { useContext } from 'react';

import { LoadableAncestorsContext } from '../LoadableAncestors.tsx';

export function useSSRPlaceholderReplaceIdProp() {
	const { placeholderReplaceId } = useContext(LoadableAncestorsContext);
	return { 'data-ssr-placeholder-replace': placeholderReplaceId };
}
